import React from 'react';
import { Link } from 'react-router-dom';
import { profile } from './profile';
import { publications } from './publications';

export default function Home() {
  const L = profile.links || {};
  const selected = publications.filter((p) => p.selected);
  return (
    <div className="page home">
      <section className="home-hero">
        <div className="home-hero-text">
          <h1 className="home-name">{profile.name}</h1>
          <p className="home-role">
            {profile.role}{profile.affiliation ? ` · ${profile.affiliation}` : ''}
          </p>
          {profile.tagline && <p className="home-tagline">{profile.tagline}</p>}
          <div className="home-links">
            {profile.email && <a href={`mailto:${profile.email}`}>Email</a>}
            {L.scholar && <a href={L.scholar} target="_blank" rel="noreferrer">Google Scholar</a>}
            {L.github && <a href={L.github} target="_blank" rel="noreferrer">GitHub</a>}
            {L.linkedin && <a href={L.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>}
            {L.twitter && <a href={L.twitter} target="_blank" rel="noreferrer">Twitter</a>}
            <Link to="/cv">CV</Link>
          </div>
        </div>
        {profile.photo && (
          <img className="home-photo" src={profile.photo} alt={profile.name} />
        )}
      </section>

      <p className="home-bio">{profile.bio}</p>

      {selected.length > 0 && (
        <section className="home-section">
          <div className="section-head">
            <h2>Selected research</h2>
            <Link className="section-more" to="/publications">All publications →</Link>
          </div>
          {selected.map((p) => (
            <article key={p.id} className="pub-card">
              <h3 className="pub-title">{p.title}</h3>
              <p className="pub-authors">{p.authors.join(', ')}</p>
              <p className="pub-venue">{p.venue}{String(p.venue).includes(String(p.year)) ? '' : ` · ${p.year}`}</p>
              <div className="pub-links">
                {p.links.arxiv && <a href={p.links.arxiv} target="_blank" rel="noreferrer">arXiv</a>}
                {p.links.code && <a href={p.links.code} target="_blank" rel="noreferrer">Code</a>}
              </div>
            </article>
          ))}
        </section>
      )}

      <section className="home-section">
        <div className="section-head">
          <h2>Photography</h2>
          <Link className="section-more" to="/gallery">Open gallery →</Link>
        </div>
        <p className="home-bio" style={{ marginTop: 0 }}>
          In my free time, I enjoy nature and wildlife photography.
        </p>
      </section>
    </div>
  );
}
